import { Button, Grid } from '@amzn/awsui-components-core';
import React, { useState } from 'react';
import constants from '../../../common/constants';
import UserIdAutosuggest from '../../common/UserIdAutosuggest';

interface LoadUserPermissionsProps {
  onLoadPermissionsClicked: (userId: string) => Promise<void>;
}
export const LoadUserPermissions = (props: LoadUserPermissionsProps) => {
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState<string>();
  const [userName, setUserName] = useState<string>();

  const handleUserSelected = (
    selectedUserId: string,
    selectedUserName: string,
    validationError: string,
  ) => {
    if (!validationError) {
      setUserId(selectedUserId);
    } else {
      setUserId(undefined);
    }
  };

  const handleLoadPermissionsClick = async () => {
    setLoading(true);
    try {
      // @ts-expect-error TS2345 - strict migration
      await props.onLoadPermissionsClicked(userId);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}>
        <UserIdAutosuggest
          userId={userId}
          userName={userName}
          onUserSelected={handleUserSelected}
        />
        <Button
          onClick={handleLoadPermissionsClick}
          loading={loading}
          wrapText={false}
          disabled={!userId}
        >
          {constants.USER_PERMISSION_MGMT_USER_SEARCH_LOAD_BUTTON_LABEL}
        </Button>
      </Grid>
    </>
  );
};
